import Breadcrumb from "components/Common/Breadcrumb"
import CustomEditor from "components/Common/CustomEditor"
import Loader from "components/Common/Loader"
import LoadingButton from "components/Common/LoadingButton"
import { axiosbaseurl } from "configure"
import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Row, Container, CardBody, Card } from "reactstrap"
import practice_logo from "../../../assets/images/users/profile.png"
import PermittedComponent from "components/Common/PermittedComponent"
import { usePermissionData } from "AppContext"

const EditPractice = () => {
  // Individual states for each field
  const [practiceName, setPracticeName] = useState("")
  const [practiceClientCode, setPracticeClientCode] = useState("")
  const [email, setEmail] = useState("")
  const [address1, setAddress1] = useState("")
  const [address2, setAddress2] = useState("")
  const [address3, setAddress3] = useState("")
  const [address4, setAddress4] = useState("")
  const [postcode, setPostcode] = useState("")

  const [goCardAccessToken, setGoCardAccessToken] = useState("")
  const [practiceDescription, setPracticeDescription] = useState("")
  const [logo, setLogo] = useState(null)
  const [logoUrl, setLogoUrl] = useState(null)
  const [errors, setErrors] = useState({})

  const [loading, setLoading] = useState(false)

  const [editorContent, setEditorContent] = useState("")

  const { practice_id } = useParams()

  const { checkAccess } = usePermissionData()
  const module_id = 5;

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const response = await axiosbaseurl.get(
          `/practice-master/${practice_id}`
        )

        setPracticeName(response.data.data.practiceName)
        setPracticeClientCode(response.data.data.practiceClientCode)
        setEmail(response.data.data.email)
        setAddress1(response.data.data.address1)
        setAddress2(response.data.data.address2)
        setAddress3(response.data.data.address3)
        setAddress4(response.data.data.address4)
        setPostcode(response.data.data.postcode)
        setGoCardAccessToken(response.data.data.goCardAccessToken)
        setPracticeDescription(response.data.data.practiceDescription)
        setEditorContent(response.data.data.companySignature)
        if (response.data.data.practiceLogo)
          setLogoUrl(
            `${process.env.REACT_APP_IMAGE_PATH}/${response.data.data.practiceLogo}`
          )
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getData()
  }, [])

  // Validation logic
  const validate = () => {
    let tempErrors = {}
    if (!practiceName) tempErrors.practiceName = "Practice Name is required."
    if (!practiceClientCode)
      tempErrors.practiceClientCode = "Client Code is required."
    if (!email || !/\S+@\S+\.\S+/.test(email))
      tempErrors.email = "Valid Email is required."
    if (!address1) tempErrors.address1 = "Address 1 is required."
    if (!postcode) tempErrors.postcode = "Postcode is required."
    if (!practiceDescription)
      tempErrors.practiceDescription = "Practice Description is required."
    if (editorContent == "<p><br></p>")
      tempErrors.editorContent = "Company Signature is required."
    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  useEffect(() => { }, [])
  document.title = "Edit Practice | Peacock Accountants Limited"

  const navigate = useNavigate()

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault()
    if (validate()) {
      const formData = new FormData()
      formData.append("practiceName", practiceName)
      formData.append("practiceClientCode", practiceClientCode)
      formData.append("email", email)
      formData.append("address1", address1)
      formData.append("address2", address2)
      formData.append("address3", address3)
      formData.append("address4", address4)
      formData.append("postcode", postcode)
      formData.append("goCardAccessToken", goCardAccessToken)
      formData.append("practiceDescription", practiceDescription)
      formData.append("companySignature", editorContent)
      formData.append("practiceLogo", logo)

      try {
        setLoading(true)
        const response = await axiosbaseurl.put(
          `/practice-master/${practice_id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )

        if (response.data.message) {
          swal("", response.data.message, "success")
          navigate(-1)
        }
      } catch (error) {
        console.log(error)

        const msg =
          error.response.data.message || error.message || "Something went Wrong"

        swal(
          "",
          msg,
          msg.includes("No changes were made !") ? "warning" : "error"
        )
      } finally {
        setLoading(false)
      }
    } else
      window.scrollTo(0, 500)
  }

  // Handle logo upload
  const handleLogoChange = e => {
    const file = e.target.files[0]
    if (file) {
      setLogo(file)
      setLogoUrl(URL.createObjectURL(file))
    }
  }

  return (
    <>
      {loading && <Loader />}
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Edit Practice"} />

          <Card className="">
            <CardBody>
              <PermittedComponent isAccess={checkAccess(module_id, "edit")}>
                <form onSubmit={handleSubmit}>
                  <div className="d-flex justify-content-between mb-4">
                    <div className="d-flex">
                      <div>
                        <label>Upload Practice Logo</label>
                        <input
                          type="file"
                          onChange={handleLogoChange}
                          className="form-control input-field"
                        />
                      </div>
                      <div className="ms-4">
                        <img
                          src={logoUrl || practice_logo}
                          width={80}
                          height={80}
                          style={{ objectFit: "contain" }}
                          alt=""
                        />
                      </div>
                    </div>
                    <div>
                      <LoadingButton loading={loading} />
                      <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="btn btn-secondary bg-dark ms-3"
                      >
                        <i className="fas fa-arrow-left me-3"></i>
                        Back
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>
                        Practice Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        value={practiceName}
                        placeholder="Enter Practice Name"
                        onChange={e => setPracticeName(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.practiceName}</span>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>
                        Practice Client Code{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Practice Client Code"
                        value={practiceClientCode}
                        onChange={e => setPracticeClientCode(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.practiceClientCode}</span>
                    </div>
                  </div>
                  <div className="row align-items-end mt-3">
                    <div className="col-md-4 mb-3">
                      <label>
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        placeholder="Enter Email "
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.email}</span>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>
                        Address 1 <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Address 1 "
                        value={address1}
                        onChange={e => setAddress1(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.address1}</span>
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Address 2</label>
                      <input
                        type="text"
                        placeholder="Enter Address 2 "
                        value={address2}
                        onChange={e => setAddress2(e.target.value)}
                        className="form-control input-field"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Address 3</label>
                      <input
                        type="text"
                        placeholder="Enter Address 3 "
                        value={address3}
                        onChange={e => setAddress3(e.target.value)}
                        className="form-control input-field"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>Address 4</label>
                      <input
                        type="text"
                        placeholder="Enter Address 4 "
                        value={address4}
                        onChange={e => setAddress4(e.target.value)}
                        className="form-control input-field"
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label>
                        Postcode <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Postcode "
                        value={postcode}
                        onChange={e => setPostcode(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.postcode}</span>
                    </div>

                    <div className="col-md-12 mb-3">
                      <label>GoCardless Access Token</label>
                      <input
                        type="text"
                        placeholder="Enter GoCard Access Token "
                        value={goCardAccessToken}
                        onChange={e => setGoCardAccessToken(e.target.value)}
                        className="form-control input-field"
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label>
                        Practice Description{" "}
                        <span className="text-danger">*</span>{" "}
                        <span className="error">
                          {errors.practiceDescription}
                        </span>
                      </label>
                      <textarea
                        placeholder="Enter Description here.."
                        value={practiceDescription}
                        onChange={e => setPracticeDescription(e.target.value)}
                        className="form-control input-field"
                        rows={4}
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label>
                        Company Signature <span className="text-danger">*</span>{" "}
                        <span className="error">{errors.editorContent}</span>
                      </label>
                      <CustomEditor
                        content={editorContent}
                        setContent={setEditorContent}
                      />
                    </div>
                  </div>
                </form>
              </PermittedComponent>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

export default EditPractice
